import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  defaultPointSize,
  defaultShapeOpacity,
} from '../../../cross-team-shared/state/layer-settings-state-3d';
import { PointCloudContentStore } from '../../state/point-cloud-content-store';

@Component({
  selector: 'h3-point-cloud-layer-view-settings-popover',
  templateUrl: './point-cloud-layer-view-settings-popover.component.html',
  styleUrls: ['./point-cloud-layer-view-settings-popover.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
/** @deprecated used for old projects without objects */
export class PointCloudLayerViewSettingsPopoverComponent {
  readonly store = inject(PointCloudContentStore);
  defaultLayerOpacity = defaultShapeOpacity;
  pointSizeStore = this.store('render')('layerSettings')('pointSize');
  defaultPointSize = defaultPointSize;
}
